(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-spare"]) return;
  try {
    
  const wishlist = JSON.parse(localStorage.getItem('recently_viewed_products') || '[]');
  if (wishlist.length > 3) {
    const raw = document.querySelector('html').dataset.root + '/';
    const prefix = raw.replace(/\/{2,}/g, '/');
    Promise.all(
      wishlist.map((handle) =>
        fetch(`${prefix}products/${handle}?view=card`)
          .then((res) => {
            if (!res.ok) return null;
            return res.text();
          })
          .then((html) => {
            if (!html) return null;

            const doc = new DOMParser().parseFromString(html, 'text/html');
            const product_card = doc.querySelector('[data-js="product-card"]');

            return product_card ? product_card.outerHTML : null;
          })
          .catch(() => null)
      )
    )
      .then((products) => {
        const container = document.getElementById('recently-container');
        const valid_products = products.filter(Boolean);

        if (valid_products.length === 0) return;

        valid_products.reverse().forEach((prod) => {
          container.insertAdjacentHTML('beforeend', prod);
        });
      })
      .then(() => {
        if (document.getElementById('recently-container')?.children.length > 0) {
          document.querySelector('.recent_products').classList.remove('hidden');
          window.dispatchEvent(new CustomEvent('product-card'));
          window.dispatchEvent(new CustomEvent('quick-buy'));
          window.dispatchEvent(new CustomEvent('wishlist'));
        }
      });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-wishlist"]) return;
  try {
    
  const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
  const recent = JSON.parse(localStorage.getItem('recently_viewed_products') || '[]');

  function renderProducts(handles, containerId) {
    if (handles.length === 0) return Promise.resolve();
    const raw = document.querySelector('html').dataset.root + '/';
    const prefix = raw.replace(/\/{2,}/g, '/');
    return Promise.all(
      handles.map((handle) =>
        fetch(`${prefix}products/${handle}?view=card`)
          .then((res) => {
            if (!res.ok) return null;
            return res.text();
          })
          .then((html) => {
            if (!html) return null;

            const doc = new DOMParser().parseFromString(html, 'text/html');
            const product_card = doc.querySelector('[data-js="product-card"]');

            return product_card ? product_card.outerHTML : null;
          })
          .catch(() => null)
      )
    ).then((products) => {
      const container = document.getElementById(containerId);
      const valid_products = products.filter(Boolean);

      if (valid_products.length === 0) return;

      valid_products.reverse().forEach((prod) => {
        container.insertAdjacentHTML('beforeend', prod);
      });
    });
  }

  function dispatchProductEvents() {
    window.dispatchEvent(new CustomEvent('product-card'));
    window.dispatchEvent(new CustomEvent('quick-buy'));
    window.dispatchEvent(new CustomEvent('wishlist'));
  }
  

  if (recent.length > 3 && wishlist.length === 0) {
    renderProducts(recent, 'recently-container').then(() => {
      document.querySelector('.recent_products').classList.remove('hidden');
      const msg = document.querySelector('[data-js="message"]')
      msg.innerHTML = msg.dataset.message;
      document.querySelector('.wishlist_loader').remove()
      dispatchProductEvents();
    });
  } else if ( wishlist.length === 0 ) {
      document.querySelector('[data-js="wishlist_top"]').classList.add("min-h-[100vh]")
      const msg = document.querySelector('[data-js="message"]')
      msg.innerHTML = msg.dataset.message;
      document.querySelector('.wishlist_loader').remove()
  }

  if (wishlist.length > 0) {
    renderProducts(wishlist, 'wishlist-container').then(() => {
      const container = document.getElementById('wishlist-container');
      container.classList.remove('hidden');
      dispatchProductEvents();
      document.querySelector('.wishlist_loader').remove()
      document.querySelectorAll('[data-js="product-card__wishlist"]').forEach((btn) => {
        btn.addEventListener('click', () => window.location.reload());
      });
    });
  }

  document.querySelector('[data-js="wishlist-clear"]')?.addEventListener('click', () => {
    localStorage.removeItem('wishlist');
    window.location.replace('/');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-selector"]) return;
  try {
    
  (() => {
    const locale = document.documentElement.lang || undefined;
    const normalize = (el) => (el?.textContent || '').trim();

    const countryList = document.querySelector('[data-js="store-selector"] .max-lg\\:hidden > div:first-child ul');

    if (countryList) {
      const items = Array.from(countryList.querySelectorAll(':scope > li'));

      items
        .sort((a, b) =>
          normalize(a.querySelector('a')).localeCompare(normalize(b.querySelector('a')), locale, {
            sensitivity: 'base',
          })
        )
        .forEach((li) => countryList.appendChild(li));
    }

    const countrySelect = document.querySelector('[data-js="store-selector-select-country"]');

    if (countrySelect) {
      const options = Array.from(countrySelect.querySelectorAll('option'));
      const placeholder = options.filter((o) => o.disabled || o.value === '');
      const countries = options.filter((o) => !o.disabled && o.value !== '');

      countries
        .sort((a, b) => normalize(a).localeCompare(normalize(b), locale, { sensitivity: 'base' }))
        .forEach((opt) => countrySelect.appendChild(opt));

      placeholder.reverse().forEach((opt) => countrySelect.insertBefore(opt, countrySelect.firstChild));
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
